/*
 * Copyright (c) 2022-2026 AccelByte Inc. All Rights Reserved
 * This is licensed software from AccelByte Inc, for limitations
 * and restrictions contact your company contract manager.
 */
import { z } from 'zod'

export const JiraData = z.object({ activeSupportTicketsURL: z.string(), id: z.string() })

export interface JiraData extends z.TypeOf<typeof JiraData> {}
